import Download from '@/views/download/Download'

export default [
    {
        path: '/download',
        name: 'download',
        component: Download,
        meta: { 
            auth: false,
            logging: true,
            pageName: '앱 다운로드',
        }
    }
]